import { Domain } from '@common/models';

export function showHelpButton(domainData: Domain): boolean {
  const { Preferences = null } = domainData ?? {}; // `null` by default for `HomeUser` and when there is no data in `Domains`

  return Preferences === null || Preferences?.HideHelpButton === false;
}
